import { Button } from '@mui/material'
import React from 'react'
import { ItemList } from '../../../UI/ItemList/ItemList'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'
import { usePutAway } from '../../Context/usePutAway'
import { useStyles } from './style'
import { LpnState } from '../../types/enums'

/*
Copyright 2022-04-11 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega generateItemList para que cuando switch SKU/Nombre cambie,
se recalcule el valor a mostrar en el listado de productos.

Copyright 2022-04-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega funcionalidad para validar si se debe mostrar lista o no,
basado en la cantidad de elementos en la lista.
*/
interface SkuListPutAwayProps {
  styleModeQuality?: boolean
}

export const SkuListPutAway = ({ styleModeQuality }: SkuListPutAwayProps) => {
  const classes = useStyles()
  const { state, dispatch } = usePutAway()
  const {
    handleRemoveItemFromList,
    terminateLocateAsn,
    setIsShowExcess,
    PatchLpnState
  } = putAwayActions()

  const { generateItemList, findWorkingLpn } = putAwayBusiness()
  const { isSelectedFieldView } = state

  // necesitamos determinar si existen elementos con sobrantes
  const determineExcess = () => {
    const areProductWithExcess = generateItemList(false).some(
      (product) => product.withExcess
    )

    return areProductWithExcess
  }

  // si presiona el boton finalizar con ubicaciones en memoria envia al metodo normal con parametro lpnstateId para que realice el cambio de estado también.
  const handlerFinalizarLpn = () => {
    if (state.SkuListOnPosition.length > 0) {
      terminateLocateAsn(LpnState.Finished, true)
    } else {
      PatchLpnState()
    }
  }

  const shouldBeShowedFinishLPNButton =
    state.item?.workingLpn && findWorkingLpn()?.lpnStateId !== LpnState.Finished

  const showOnlyIfAtLeastOneSKUIsSelected = state.SkuListOnPosition.length > 0

  return (
    <div id='containerGridPutAway' className={classes['#containerGridPutAway']}>
      {showOnlyIfAtLeastOneSKUIsSelected && (
        <ItemList
          items={generateItemList(isSelectedFieldView === 'skuId')}
          click={(name, batchId) => handleRemoveItemFromList(name, batchId)}
          styleModeQuality={styleModeQuality}
        />
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          padding: '10px'
        }}
      >
        {showOnlyIfAtLeastOneSKUIsSelected && (
          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            onClick={() => {
              if (determineExcess()) {
                dispatch(setIsShowExcess(true))
              } else {
                terminateLocateAsn()
              }
            }}
          >
            Terminar ubicación
          </Button>
        )}
        {shouldBeShowedFinishLPNButton && (
          <Button
            type='submit'
            fullWidth
            variant='contained'
            style={{
              backgroundColor: '#32CD32'
            }}
            onClick={handlerFinalizarLpn}
          >
            Finalizar LPN
          </Button>
        )}
      </div>
    </div>
  )
}
